import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { ChatWidget } from "./components/ChatWidget";
import { RedirectHandler } from "./components/RedirectHandler";
import { AuthProvider } from "./context/AuthContext";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Quote } from "./pages/Quote";
import { TemporaryInsurance } from "./pages/TemporaryInsurance";
import { CarteGrise } from "./pages/CarteGrise";
import { MentionsLegales } from "./pages/MentionsLegales";
import { Blog } from "./pages/Blog";
import { Partners } from "./pages/Partners";
import { NotFound } from "./pages/NotFound";
import { Login } from "./pages/Login";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { AdminApporteurs } from "./pages/admin/AdminApporteurs";
import { AdminContracts } from "./pages/admin/AdminContracts";
import { AdminCommissions } from "./pages/admin/AdminCommissions";
import { AdminLeads } from "./pages/admin/AdminLeads";
import { ApporteurDashboard } from "./pages/apporteur/ApporteurDashboard";

// Layout component that conditionally shows header/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isApporteurRoute = location.pathname.startsWith('/apporteur');
  const isLoginRoute = location.pathname === '/login';
  const hideLayout = isAdminRoute || isApporteurRoute || isLoginRoute;

  return (
    <>
      {!hideLayout && <Header />}
      {children}
      {!hideLayout && <Footer />}
      {!hideLayout && <ChatWidget />}
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <RedirectHandler />
            <Layout>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/quote" element={<Quote />} />
                <Route path="/assurance-temporaire" element={<TemporaryInsurance />} />
                <Route path="/carte-grise" element={<CarteGrise />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/partenaires" element={<Partners />} />
                
                {/* Auth Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                
                {/* Admin Routes */}
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/apporteurs" element={<AdminApporteurs />} />
                <Route path="/admin/contracts" element={<AdminContracts />} />
                <Route path="/admin/commissions" element={<AdminCommissions />} />
                <Route path="/admin/leads" element={<AdminLeads />} />
                
                {/* Apporteur Routes */}
                <Route path="/apporteur" element={<ApporteurDashboard />} />
                
                {/* 404 for unknown pages - RedirectHandler handles old URLs */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
